export default {
  sui: {
    loading: {
      text: '拼命加载中'
    },
    form: {
      more: '更多',
      zhankai: '展开',
      shouqi: '收起',
      query: '查询',
      reset: '重置',
      add: '新增',
      update: '编辑',
      delete: '删除',
      required: '不能为空',
      export: {
        export: '导出',
        selectFormat: '选择格式',
        selectedRow: '已选择{key}列',
        selectedTotal: '共{key}行,导出第',
        line: '行'
      },
      please: {
        input: '请输入',
        select: '请选择'
      },
      time: {
        start: '开始时间',
        end: '结束时间',
        to: '至'
      },
      date: {
        start: '开始日期',
        end: '结束日期'
      },
      upload: {
        triggerText: '上传'
      },
      expand: '展开',
      multiple: '多选',
      cols_hide: '表头设置'
    },
    table: {
      handle: '操作',
      sum: '合计',
      index: '序号',
      zanwushuju: '暂无数据',
      queding: '确定',
      quxiao: '取消',
      lie: '列',
      yiyincang: '已隐藏',
      gong: '共'
    },
    tableEdit: {
      tip1: '还有数据处于编辑状态，不能保存！',
      tip2: '是否确定删除该条数据？',
      baocun: '保存',
      chongzhi: '重置',
      xinzeng: '新增',
      guanbituozhuai: '关闭拖拽',
      kaiqituozhuai: '开启拖拽',
      caozuo: '操作',
      queren: '确认',
      bianji: '编辑',
      shanchu: '删除',
      tishi: '提示'
    },
    list: {
      yi_xuan_ze: '已选择',
      tiao: '条',
      gong: '共',
      mei_you_geng_duo: '没有更多了~',
      zan_wu_shu_ju: '暂未选中任何数据'
    },
    bond: {
      zheng_quan_dai_ma: '证券代码',
      zheng_quan_ming_cheng: '证券名称',
      zan_wu_shu_ju: '暂无数据',
      qu_xiao_qing_qiu: '请求被取消'
    },
    dialog: {
      ok: '确认',
      cancel: '取消'
    },
    page: {
      add: {
        success: '新增[{key}]成功'
      },
      delete: {
        title: '{key}-删除',
        confirm: '确认删除[{key}]吗？',
        success: '删除[{key}]成功'
      },
      update: {
        success: '修改[{key}]成功',
        noChange: '数据没有修改，不用保存！'
      }
    },
    tablePage: {
      export: {
        tip1: '请输入正确行号',
        tip2: '导出方式',
        tip3: '将已选的',
        tip4: '导出为',
        tip5: '请选择导出格式',
        lie: '列',
        hang: '行',
        shi: '是',
        fou: '否',
        daochu: '导出',
        wancheng: '完成',
        quxiao: '取消',
        gong: '共',
        type1: '顺序导出',
        type2: '手动勾选导出',
        daochu_geshi: '导出格式'
      }
    },
    editlist: {
      caozuo: '操作',
      shanchu: '删除',
      xinzeng: '新增'
    },
    upload: {
      tip1: '按delete键可删除'
    },
    uploadPro: {
      tip1: 'WebSocket 连接断开，正在尝试重新连接',
      tip2: '连接已断开'
    },
    select: {
      jiazaizhong: '加载中',
      wupipeishuju: '无匹配数据',
      wushuju: '无数据',
      quanxuan: '全选',
      fanxuan: '反选'
    },
    transfer: {
      tip1: '搜索',
      liebiao1: '列表 1',
      liebiao2: '列表 2'
    },
    treeGrid: {
      caozuolan: '操作栏'
    },
    empty: {
      zanwuneirong: '暂无内容'
    },
    valid: {
      char: '字符',
      len1: '请输入{p1}个',
      len2: '请输入{p1}到{p2}个',
      pInt: '正整数',
      npInt: '非正整数',
      nInt: '负整数',
      nNInt: '非负整数',
      int: '整数',
      pFNum: '正浮点数',
      nFNum: '负浮点数',
      num: '数字字符',
      num_: '数字(短杠,下划线)字符',
      en: '英文字符',
      en_: '英文(短杠,下划线)字符',
      ch: '中文字符',
      ch_: '中文(短杠,下划线)字符',
      nch: '非中文字符',
      numEn: '数字英文字符',
      numEn_: '数字英文(短杠,下划线)字符',
      chEnNum: '数字英文或中文字符',
      chEnNum_: '数字英文或中文(短杠,下划线)字符',
      phone: '手机号码',
      email: '邮箱',
      idcard: '身份证号',
      url: 'url地址',
      reg: '请输入正确格式的',
      version: '版本号',
      uri: 'uri',
      datasource: '数据源',
      intRegion: '整数区域长度{p1}到{p2}位',
      floatRegion: '精度区域长度{p1}到{p2}位'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: '绝对时间范围',
      xiang_dui_shi_jian_fan_wei: '相对时间范围',
      kai_shi_shi_jian: '开始时间',
      jie_su_shi_jian: '结束时间',
      zui_jin_wu_fen_zhong: '最近五分钟',
      zui_jin_shi_wu_fen_zhong: '最近十五分钟',
      zui_jin_san_shi_fen_zhong: '最近三十分钟',
      zui_jin_yi_xiao_shi: '最近一小时',
      zui_jin_san_xiao_shi: '最近三小时',
      zui_jin_liu_xiao_shi: '最近六小时',
      zui_jin_shi_er_xiao_shi: '最近十二小时',
      zui_jin_er_shi_si_xiao_shi: '最近二十四小时',
      zui_jin_liang_tian: '最近两天',
      zui_jin_qi_tian: '最近七天',
      zui_jin_san_shi_tian: '最近三十天'
    },
    bookmark: {
      biao_ti: '书签',
      xin_zeng_shu_qian: '新增书签',
      ming_cheng: '名称',
      fu_gai: '覆盖',
      chong_ming_ming: '重命名',
      shan_chu: '删除',
      ming_cheng_xiu_gai_cheng_gong: '名称修改成功',
      xin_zeng: '新增',
      shan_chu_ti_shi: '确认删除[{name}]吗？',
      shan_chu_cheng_gong: '删除成功',
      xin_zeng_cheng_gong: '新增书签成功！',
      tian_jia_ji_lu: '添加为历史记录',
      gong: '共',
      tiao: '条',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: '请确认正在新增记录',
      bao_cun: '保存'
    },
    messageBox: {
      qing_shuru_yanzhengma: '请输入验证码',
      yanzhengma_bu_zhengque: '验证码不正确'
    },
    jsonEditor: {
      fuzhi: '复制'
    },
    cron: {
      second: '秒',
      minute: '分钟',
      hour: '时',
      day: '日',
      month: '月',
      week: '周',
      year: '年',
      cron_biaodashi_ziduan: 'Cron表达式字段',
      hanhua_fanyi: '汉化翻译',
      chongzhi: '重置',
      single: '每',
      mei_nian: '每年',
      mei_yue: '每月',
      mei_ri: '每日',
      mei_tian: '每天',
      mei_shi: '每小时',
      xiaoshi: '小时',
      mei_fenzhong: '每分钟',
      mei_miao: '每秒',
      mei_zhou: '每周',
      cong: '从',
      yue_qi_mei_ge: '月起每隔',
      ri_qi_mei_ge: '日起每隔',
      shi_qi_mei_ge: '时起每隔',
      fenzhong_qi_mei_ge: '分钟起每隔',
      miao_qi_mei_ge: '秒起每隔',
      zuihou_yitian: '最后一天',
      zhi: '至',
      cong_zhou: '从周',
      zhi_zhou: '至周',
      qi_meige: '起每隔',
      tian_zhixingyici: '天执行一次',
      xiaoshi_zhixingyici: '小时执行一次',
      yue_zhixingyici: '月执行一次',
      zhixingyici: '执行一次',
      ben_yue_di: '本月第',
      ben_yue: '本月',
      xinqi: '星期',
      benyue_zuihou_yige_xingqi: '本月最后一个星期',
      buzhiding: '不指定',
      zhouqi_cong: '周期从',
      xunhuan_cong: '循环从',
      tip1: '日开始，每',
      tip2: '日最近的那个工作日',
      tip3: '时开始，每',
      tip4: '月开始，每',
      tip5: '周的星期',
      benyue_zuihou_yitian: '本月最后一天',
      zhiding: '指定',
      kaishi: '开始',
      kaishi_mei: '开始每',
      benyue: '本月',
      mei: '每',
      zhixing: '执行',
      zhouqi: '周期',
      di: '第',
      mess1: '日期与星期不可以同时为“不指定”',
      mess2: '日期与星期必须有一个为“不指定”',
      zhouri: '周日',
      zhouyi: '周一',
      zhouer: '周二',
      zhousan: '周三',
      zhousi: '周四',
      zhouwu: '周五',
      zhouliu: '周六'
    },
    treeGraph: {
      fangda: '放大',
      suoxiao: '缩小',
      shuaxin: '刷新'
    },
    processDesigner: {
      shiyong_quanju_yangshi: '使用全局样式',
      xianlei_xin: '线类型',
      yanse: '颜色',
      jiantou_leixin: '箭头类型',
      biaoqian_shezhi: '标签设置',
      qingshu_ru: '请输入',
      yulan_tai: '预览态',
      tuzi_shiying: '图自适应',
      kaiqi: '开启',
      guanbi: '关闭',
      beijing_shezhi: '背景设置',
      xianshi_wangge: '显示网格',
      beijing_tupian_shezhi: '背景图片设置',
      tupian_dizhi: '图片地址',
      chongfu_fangshi: '重复方式',
      chongfu_fangshi_tip:
        '支持所有 CSS background-repeat 属性的取值，另外，还支持以下几个预定义值：watermark(水印效果)、 flip-x(水平翻转背景图片)、 flip-y(垂直翻转背景图片)、flip-xy (水平和垂直翻转背景图片)。',
      tupian_weizhi: '图片位置',
      tupian_weizhi_tip: '支持所有 CSS background-position 属性的取值',
      tupian_daxiao: '图片大小',
      tupian_daxiao_tip: '支持所有 CSS background-size属性的取值',
      touming_du: '透明度',
      beijing_se: '背景色',
      biankuang_se: '边框色',
      biankuang_yuanjiao: '边框圆角',
      wenben: '文本',
      x_tip: 'X 坐标，以节点左上角为原点，-1表示居中显示',
      y_tip: 'Y 坐标，以节点左上角为原点，-1表示居中显示',
      ziti: '字体',
      tubiao_shezhi: '图标设置',
      kuan: '宽',
      gao: '高',
      lujing: '路径',
      fubiao_qianshe_zhi: '副标签设置',
      huibiao_zheshi: '徽标设置',
      xianshi_huibiao: '显示徽标'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/zh-CN.js